import { useEffect, useRef } from "react";

export default function useScrollTrigger(
	threshold: number,
	callback: (flag: boolean) => void,
): void {
	const prevFlag = useRef<boolean | null>(null);

	useEffect(() => {
		let ticking = false;

		const handleScroll = () => {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(() => {
					const currentFlag = window.scrollY > threshold;
					if (prevFlag.current !== currentFlag) {
						callback(currentFlag);
						prevFlag.current = currentFlag;
					}
					ticking = false;
				});
			}
		};

		window.addEventListener("scroll", handleScroll, { passive: true });

		handleScroll();

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [threshold, callback]);
}
